import { Check } from 'lucide-react';

/** Signing up is one wizard, even though the account is created halfway
 *  through it and the rest happens on another route. */
export const SIGNUP_STEPS = ['Your details', 'Confirm email', 'Plan', 'Organisation', 'Done'];

export default function WizardSteps({ current }: { current: number }) {
  return (
    <ol className="flex flex-wrap items-center gap-2 text-xs" data-testid="onboarding-steps">
      {SIGNUP_STEPS.map((label, index) => (
        <li key={label} className="flex items-center gap-2">
          <span
            className={`flex h-6 w-6 items-center justify-center rounded-full border text-[11px] ${
              index < current
                ? 'border-amber-500 bg-amber-500 text-white'
                : index === current
                  ? 'border-amber-500 text-amber-600'
                  : 'border-muted text-muted-foreground'
            }`}
          >
            {index < current ? <Check className="h-3 w-3" /> : index + 1}
          </span>
          <span className={index === current ? 'font-medium' : 'text-muted-foreground'}>
            {label}
          </span>
          {index < SIGNUP_STEPS.length - 1 && <span className="text-muted-foreground">·</span>}
        </li>
      ))}
    </ol>
  );
}
